import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";

import Amplify from "aws-amplify";
import "@aws-amplify/ui-vue";
import aws_exports from "./aws-exports";

import {
  LayoutPlugin,
  //IconsPlugin,
  NavbarPlugin,
  BSpinner,
  BButton,
} from "bootstrap-vue";

import "./scss/custom.scss";

Amplify.configure(aws_exports);

Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);
Vue.component("b-spinner", BSpinner);
Vue.component("b-button", BButton);
//Vue.use(IconsPlugin);

Vue.config.productionTip = false;

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);
Vue.prototype.$scrollTo = (y) => window.scrollTo({ top: y, behavior: "smooth" });

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

import "./scss/material-kit.scss";
